import { Pressable, StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';

import { colors, fonts, fontSizes, spacing } from '@/constants/theme';

import { Heading } from './Heading';

export interface SectionHeaderProps {
  title: string;
  /** Right-aligned link, e.g. "View all →". Optional. */
  actionLabel?: string;
  onActionPress?: () => void;
  style?: StyleProp<ViewStyle>;
}

/**
 * Standard "Available Deals  /  View all →" pattern from the handoff
 * (`mp-sec-h`). Title is a 2xl Heading (FK Screamer, Deep Green); action is a
 * compact muted link on the right.
 */
export function SectionHeader({
  title,
  actionLabel,
  onActionPress,
  style,
}: SectionHeaderProps) {
  return (
    <View style={[styles.row, style]}>
      <Heading size="2xl" style={styles.title}>{title}</Heading>
      {actionLabel && onActionPress && (
        <Pressable
          onPress={onActionPress}
          hitSlop={8}
          accessibilityRole="link"
          accessibilityLabel={actionLabel}
        >
          {({ pressed }) => (
            <Text style={[styles.action, pressed && styles.actionPressed]}>
              {actionLabel}
            </Text>
          )}
        </Pressable>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.lg,
    marginTop: spacing.lg,
    marginBottom: spacing.md,
  },
  title: {
    flex: 1,
  },
  action: {
    fontFamily: fonts.bodyBold,
    fontSize: fontSizes.xs,
    color: colors.textMuted,
  },
  actionPressed: {
    opacity: 0.6,
  },
});
